import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { JwtService } from '../services/jwt.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private jwtService: JwtService,
    private router: Router,
    private authService: AuthService,
  ) { }

  canActivate(): Observable<boolean | UrlTree> {
    return this.jwtService.currentJwtPayload$.pipe(
      take(1),
      switchMap(payload => {
        if (
          payload &&
          !this.jwtService.isExpired(payload)
        ) {
          return this.authService.loadProfileIfNeeded().pipe(
            take(1),
            map(user => {
              if (user && (user.isAdmin || user.role)) {
                return true;
              }
              this.authService.logout();
              return this.router.createUrlTree(['/auth/login']);
            }),
          );
        }
        return of(this.router.createUrlTree(['/auth/login']));
      })
    );
  }
}
